<template>
  <div class="container">
    <div class="comment_wrap">
      <!-- Comment 1 -->
      <div
        data-aos="fade-right"
        data-aos-duration="600"
        data-aos-offset="-400"
        data-aos-delay="0"
        class="comment_item left_align"
      >
        <div class="bubble">
          <p>Dentrion's technicians combine digital</p>
          <p>expertise with exceptional craftsmanship to</p>
          <p>create prosthetics with perfect fit,</p>
          <p>making chairside seating effortless.</p>
          <p class="doctor_name">K** Doctor</p>
          <img class="emoji SmileLove" src="../assets/emoji/SmileLove.svg" alt="SmileLove" />
        </div>
      </div>

      <!-- Comment 2 -->
      <div
        data-aos="fade-left"
        data-aos-duration="600"
        data-aos-offset="-400"
        data-aos-delay="100"
        class="comment_item right_align"
      >
        <div class="bubble">
          <p>The tooth designs are outstanding and</p>
          <p>color matching is spot-on, leading to</p>
          <p>high patient satisfaction.</p>
          <p class="doctor_name">P** Doctor</p>
          <img class="emoji starEyes" src="../assets/emoji/starEyes.svg" alt="starEyes" />
          <img class="emoji star2" src="../assets/emoji/star.svg" alt="star" />
        </div>
      </div>

      <!-- Comment 3 -->
      <div
        data-aos="fade-right"
        data-aos-duration="600"
        data-aos-offset="-400"
        data-aos-delay="200"
        class="comment_item left_align"
      >
        <div class="bubble">
          <p>The jigs and custom abutments provide</p>
          <p>excellent retention. Their ordering platform is</p>
          <p>intuitive, and packaging is professional.</p>
          <p class="doctor_name">H** Doctor</p>
          <img class="emoji HeartRibbon" src="../assets/emoji/HeartRibbon.svg" alt="HeartRibbon" />
          <img class="emoji SmileFace" src="../assets/emoji/SmileFace.svg" alt="SmileFace" />
        </div>
      </div>

      <!-- Comment 4 -->
      <div
        data-aos="fade-left"
        data-aos-duration="600"
        data-aos-offset="-400"
        data-aos-delay="300"
        class="comment_item right_align"
      >
        <div class="bubble">
          <p>They quickly implement feedback with</p>
          <p>precise understanding of our needs.</p>
          <p>Their prosthetic quality is outstanding.</p>
          <p class="doctor_name">S** Doctor</p>
          <img class="emoji SurpriseFace" src="../assets/emoji/SurpriseFace.svg" alt="SurpriseFace" />
          <img class="emoji ThumbsUp" src="../assets/emoji/ThumbsUp.svg" alt="ThumbsUp" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.container {
  width: 100%;
  background-color: #000;
  padding: 80px 32px 60px 32px;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}

.comment_wrap {
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 600px;
  width: 100%;
}

.comment_item {
  position: relative;
  width: 100%;
  display: flex;
}

.right_align {
  justify-content: flex-end;
}

.right_align .bubble {
  border-bottom-right-radius: 4px;
}

.left_align {
  justify-content: flex-start;
}

.left_align .bubble {
  border-bottom-left-radius: 4px;
}

.bubble {
  background-color: #fff;
  width: 328px !important;
  border-radius: 24px;
  box-shadow: 2px 4px 40px 0 #51C37E;
  position: relative;
  display: inline-block;
  z-index: 1;
  padding: 16px 24px;
  box-sizing: border-box;
}
.bubble > p{
  color: #0B485B;
  font-family: "IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  line-height: 128%; 
  letter-spacing: -0.8px;
}

.bubble > .doctor_name {
  color: #121212;
  font-family: "Wanted Sans", -apple-system, BlinkMacSystemFont, system-ui,
    Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR",
    "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 128%; 
  letter-spacing: -0.7px;
  margin-top: 16px;
}

/* Emojis */
.emoji {
  position: absolute;
  z-index: 2;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
}

/* Comment 1 Decorations */
.SmileLove {
  width: 80px;
  bottom: 10%;
  right: -10%;
}

/* Comment 2 Decorations */
.starEyes {
  width: 58px;
  bottom: -10%;
  left: 74%;
}

.star2 {
  width: 28px;
  bottom: 30%;
  right: 2%;
}

/* Comment 3 Decorations */
.HeartRibbon{
  width: 34px;
  bottom: 5%;
  right: 12%;
}
.SmileFace {
  width: 60px;
  bottom: -14%;
  right: -8%;
  transform: scaleX(-1);
}

/* Comment 4 Decorations */

.SurpriseFace {
  width: 60px;
  bottom: -22%;
  right: 8%;
}

.ThumbsUp {
  width: 50px;
  bottom: 8%;
  right: -5%;
  transform: rotate(-5deg);
}
</style>
